import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Http } from "../../../../../../helpers/axois";
import { AppState } from '../../../../../../stateManager/store';
import { getRandomId } from '../../../../../../utils/random-id';
import { useToast, encodeBase64 } from '../../../../../../helpers/commonFunction';
import { createAsset } from '../../../../../../stateManager/store/formCreation_v2/actions';
import { logger } from '../../../../../../constant/winston';

export const CreateAsset = (props:any) => {
  const {assetEditModeEnabled } = props;
  const dispatch = useDispatch()
  const [name, setName] = useState("");
  const orgId = useSelector((state: AppState) => state.org.selectedOrg?.id)
  const { ErrorToast, SuccessToast } = useToast()
  const [err, setErr] = useState("")
  const assets = useSelector((state: AppState) => state.formJson.assets)
  

  const handleCreateAsset = async () => {
    const label = name.trim()

    if (!label) {
      setErr("asset name cannot be empty")
      return
    }

    const assetLabels = Object.keys(assets).map(key => assets[key].label)
    if (assetLabels.includes(label)) {
      setErr("an asset with this name already exists")
      return
    }

    const assetId = getRandomId()
    const json: any = {
      type: "a8solo",
      components: {},
      componentOrder: [],
    }
    const payload = {
      assetId,
      label,
      source: encodeBase64(JSON.stringify(json))
    }
    const { ok: isAssetSaved, id: rId } = await saveAsset(payload)
    if (isAssetSaved) {
      dispatch(createAsset({
        id: assetId,
        asset: {
          id: rId,
          assetId,
          label,
          json,
        },
      }))
      SuccessToast("Added asset")
      setName("")
    } else {
      ErrorToast("Failed to create asset")
    }
  }

  const saveAsset = async (payload: {
    assetId: string
    label: string
    source: string
  }) => {
    try {
      const res: any = await Http.post(`/orgs/${orgId}/assets`, payload).toPromise()
      return { ok: res.ok, id: res?.data?.id }
    } catch (e) {
      logger.debug(`failed to save asset: `, e)
      return { ok: false, id: "" }
    }
  }

  return (
    <div className="px-3 py-1">
      <div className="flex gap-6">
        <input
          disabled={assetEditModeEnabled}
          className="flex-1 focus:outline-none pl-2 font-medium"
          type="text"
          placeholder="Enter asset name"
          value={name}
          onChange={(e) => { setErr(""); setName(e.target.value) }}
          style={{
            borderBottom: "2px solid rgba(125, 132, 146, 0.294)",
          }}
        />
        <button
          disabled={assetEditModeEnabled}
          className="rounded-md px-4 py-2 text-white"
          style={{
            cursor: assetEditModeEnabled ? "not-allowed" : "pointer",
            fontFamily: "inherit",
            background: "#052f35 ",
          }}
          onClick={handleCreateAsset}
        >
          Add
        </button>
      </div>
      {Boolean(err) && <p style={{ margin: 0, padding: 4, color: 'red' }}>{err}</p>}
    </div>
  );
};
